// 🛡️ Community auto-hide, LIVE (09-29, SPACES_REDESIGN §7). Three reports hide a
// person's line or a ghost line server-side (moderationReports.js), and the
// server broadcasts `action_hidden` to the room. The page ignored that message,
// so a hidden line stayed on every open screen until a reload. These swap the
// line for the same words every server read now serves (the backend's
// HIDDEN_BY_REPORTS_COPY) and drop its GIF.
//
// Pure. Each returns the SAME array when the id is not there or the line is
// already masked, so an unknown id or a re-delivery never re-renders the feed
// (the status poll re-delivers every recent line every few seconds).

export const HIDDEN_LINE_COPY = '🚫 Hidden after community reports';
const GIF_KEYS = ['gif_url', 'gif_preview_url', 'gif_title'];
const isMasked = (obj) => !!obj && obj.message === HIDDEN_LINE_COPY && !obj.gif_url && !obj.gif_preview_url;

const maskFields = (obj) => {
  const out = { ...(obj || {}), message: HIDDEN_LINE_COPY, hidden_by_reports: true };
  GIF_KEYS.forEach((k) => { delete out[k]; });
  return out;
};

// The feed: `results` is [{ ...payload, actions: [{ id, type, data }] }].
export function hideActionInResults(results, actionId) {
  if (!actionId || !Array.isArray(results)) return results;
  let hit = false;
  const next = results.map((r) => {
    const actions = r && Array.isArray(r.actions) ? r.actions : null;
    if (!actions || !actions.some((a) => a && a.id === actionId && !isMasked(a.data))) return r;
    hit = true;
    return { ...r, actions: actions.map((a) => (a && a.id === actionId ? { ...a, data: maskFields(a.data) } : a)) };
  });
  return hit ? next : results;
}

// The ghost lines: flat { id, message, gif_url, gif_title, ... } items.
export function hideGhostLine(lines, actionId) {
  if (!actionId || !Array.isArray(lines) || !lines.some((m) => m && m.id === actionId && !isMasked(m))) return lines;
  return lines.map((m) => {
    if (!m || m.id !== actionId) return m;
    const out = maskFields(m);
    out.gif_url = null; // the panel reads these as "no GIF"
    out.gif_title = null;
    return out;
  });
}
